import { defineComponent as _defineComponent } from 'vue'
import WizardStep from '@/components/wizard/WizardStep.vue';
import { useI18n } from '@/composables/i18n';
import { StandardAlertEligibleDevice } from '@/models/standardAlert';
import { computed } from 'vue';
import { uniq } from '@/utils/array';


export default /*#__PURE__*/_defineComponent({
  __name: 'ApplicationSummaryWizardStep',
  props: {
    finalDevices: null
  },
  setup(__props: any) {

const props = __props as {
  finalDevices: StandardAlertEligibleDevice[];
};



const { t } = useI18n();

const numberOfCustomers = computed<number>(
  () =>
    uniq(
      props.finalDevices.map((eligibleDevice) => eligibleDevice.customerName),
    ).length,
);

const numberOfEquipment = computed<number>(() => props.finalDevices.length);

return { __sfc: true,props, t, numberOfCustomers, numberOfEquipment, WizardStep }
}

})